import { render, staticRenderFns } from "./TaxPurposeSettings.vue?vue&type=template&id=30dabaac&scoped=true&"
import script from "./TaxPurposeSettings.vue?vue&type=script&lang=js&"
export * from "./TaxPurposeSettings.vue?vue&type=script&lang=js&"
import style0 from "./TaxPurposeSettings.vue?vue&type=style&index=0&id=30dabaac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dabaac",
  null
  
)

export default component.exports